module.exports = __webpack_public_path__ + "static/media/certEmblem.11950866.png";